// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p9-1";
export var messageSideRight = "_p9-2";
export var subscribeToBackInStockBubbleContainer = "_p9-0";